import React from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import AlertComponent from "../../../../_metronic/_helpers/AlertComponent";
import {lighten, makeStyles} from "@material-ui/core/styles";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import PlusIcon from "@material-ui/icons/Add";
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import MoneyOffIcon from '@material-ui/icons/MoneyOff';
import CheckIcon from '@material-ui/icons/Check';
import InfoIcon from "@material-ui/icons/Info";
import {format} from "date-fns";
import axios from "axios"
import {azAZ} from '@material-ui/core/locale';
import {useSelector} from "react-redux";

import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Toolbar,
    Paper,
    Tooltip,
    CircularProgress, TableSortLabel,
    createMuiTheme,
    ThemeProvider,
} from "@material-ui/core";
import TablePagination from "@material-ui/core/TablePagination/index";
import EyeIcon from "@material-ui/icons/RemoveRedEye";
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';


const theme = createMuiTheme(azAZ);

const headRows = [
    {
        id: "code",
        numeric: false,
        disablePadding: true,
        label: "Tur kodu",
    },
    {
        id: "betStartDate",
        numeric: false,
        disablePadding: true,
        label: "Mərcin başlama tarixi",
    },
    {
        id: "expiredDate",
        numeric: false,
        disablePadding: true,
        label: "Mərcin bitmə tarixi",
    },
    {
        id: "product.Name",
        numeric: false,
        disablePadding: true,
        label: "Məhsulun adı",
    },
    {
        id: "totalAmount",
        numeric: false,
        disablePadding: true,
        label: "Hovuz məbləği",
    },
    {
        id: "circulationJackpot",
        numeric: false,
        disablePadding: true,
        label: "Cekpot məbləği",
    },
    {
        id: "operations",
        numeric: false,
        disablePadding: true,
        label: "Turun dəyərləndirilməsi",
    },
    {
        id: "resultedDate",
        numeric: false,
        disablePadding: true,
        label: "Turun dəyərləndirilmə tarixi",
    },
    {
        id: "operations",
        numeric: false,
        disablePadding: true,
        label: "Əməliyyatlar",
    },
];

function EnhancedTableHead({onRequestSort, sortField, orderBy}) {
    return (
        <TableHead>
            <TableRow>
                {headRows.map((row, index) => {
                    if (row.id === "operations") {
                        return (
                            <TableCell key={index}
                                       align="center">
                                <div>
                                    {row.label}
                                </div>
                            </TableCell>
                        )
                    } else {
                        return (
                            <TableCell sortDirection={sortField === row.id ? "asc" : false} key={index}
                                       align={row.numeric ? "right" : "left"}>
                                <TableSortLabel active={sortField === row.id} direction={orderBy ? "asc" : "desc"}
                                                onClick={() => {
                                                    onRequestSort(row.id)
                                                }}>
                                    {row.label}
                                </TableSortLabel>
                            </TableCell>
                        )
                    }
                })}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
    root: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(1),
        justifyContent: "flex-end",
    },
    highlight:
        theme.palette.type === "light"
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85),
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.secondary.dark,
            },
    actions: {
        color: theme.palette.text.secondary,
    },
    title: {
        flex: "0 0 auto",
    },
    dense: {
        margin: theme.spacing(2),
    },
}));

const EnhancedTableToolbar = (props) => {
    const classes = useToolbarStyles();
    const {numSelected, setShowCreate, Circulation_Create} = props;

    return (
        <Toolbar
            className={clsx(classes.root, {
                [classes.highlight]: numSelected > 0,
            })}
        >
            <div className={classes.actions}>
                {Circulation_Create && (
                    <Tooltip title="Yarat" placement="top">
                        <button
                            className="flex-shrink-0 btn btn-sm btn-icon btn-bg-light btn-text-primary btn-hover-primary mr-2 h5 rounded-circle flex-shrink-0"
                            onClick={() => setShowCreate(true)}
                        >
                            <PlusIcon/>
                        </button>
                    </Tooltip>
                )}
            </div>
        </Toolbar>
    );
};

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        marginTop: theme.spacing(3),
    },
    paper: {
        width: "100%",
        marginBottom: theme.spacing(2),
    },
    table: {
        minWidth: 750,
    },
    tableWrapper: {
        overflowX: "auto",
    },
    progresRoot: {
        width: "100%",
        padding: "32px 16px",
    },
    progress: {
        margin: "auto",
        display: "block",
        color: "#e2241b",
    },
}));

export default function EnhancedTable({
                                          groups,
                                          onGroups,
                                          isLoading,
                                          isError,
                                          setText,
                                          setChooseGroupId,
                                          setOpenView,
                                          setShowCreate,
                                          setShowRemove,
                                          setShowRemoveGroups,
                                          setShowCheckGames,
                                          setShowEdit,
                                          deleteGroupsIds,
                                          setDeleteGroupsIds,
                                          sortField,
                                          setSortField,
                                          orderBy,
                                          setOrderBy,
                                          totalCount,
                                          setSkip,
                                          skip,
                                          take,
                                          setTake,
                                          setCirculationNumber,
                                          setShowCirculationActivation,
                                          setIsActivate,
                                          setReasons,
                                          setShowReasons
                                      }) {
    const classes = useStyles();

    const {
        Circulation_Create,
        Circulation_Update,
        Circulation_Delete,
        Circulation_SaveResult
    } = useSelector(state => state.auth.user.permissions)

    function handleSelectAllClick(event) {
        if (event.target.checked) {
            const newSelecteds = groups.map((n) => n.id);
            setDeleteGroupsIds(newSelecteds);
            return;
        }
        setDeleteGroupsIds([]);
    }

    const isSelected = (name) => deleteGroupsIds.indexOf(name) !== -1;

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);

    const handleRequestSort = (field) => {

        const isOrder = (field === sortField && !orderBy)

        setSortField(field);
        setOrderBy(isOrder);
        setTake(10);
        setRowsPerPage(10);
        setSkip(0);
        setPage(0);

    };

    function handleChangePage(event, newPage) {
        setPage(newPage);
        setSkip(newPage * take);
    }

    function handleChangeRowsPerPage(event) {
        setRowsPerPage(+event.target.value);
        setTake(+event.target.value);
        setPage(0);
        setSkip(0);
    }

    const putSeeTotalAmount = (id, boolean) => {
        return axios.put(`circulations/seeTotalAmount?id=${id}&seeTotalAmount=${boolean}`)
            .then(() => {
                onGroups({skip, take, orderBy, sortField})
            })
            .catch((err) => {
                console.log(err)
            })
    }

    return (
        <div className={classes.root}>
            <Paper className={classes.paper}>
                <EnhancedTableToolbar
                    numSelected={deleteGroupsIds.length}
                    setText={setText}
                    setShowCreate={setShowCreate}
                    setShowRemoveGroups={setShowRemoveGroups}
                    Circulation_Create={Circulation_Create}
                />
                {isLoading && (
                    <div className={classes.progresRoot}>
                        <CircularProgress className={classes.progress}/>
                    </div>
                )}
                <div className={classes.tableWrapper}>
                    {groups.length ? (
                        <Table className={classes.table} aria-labelledby="tableTitle">
                            <EnhancedTableHead
                                numSelected={deleteGroupsIds.length}
                                onSelectAllClick={handleSelectAllClick}
                                rowCount={groups.length}
                                onRequestSort={handleRequestSort}
                                sortField={sortField}
                                orderBy={orderBy}
                            />
                            <TableBody>
                                {groups.map((row, index) => {
                                    const isItemSelected = isSelected(row.id);
                                    const labelId = `enhanced-table-checkbox-${index}`;
                                    return (
                                        <TableRow
                                            hover
                                            role="checkbox"
                                            aria-checked={isItemSelected}
                                            tabIndex={-1}
                                            key={index}
                                            selected={isItemSelected}
                                        >
                                            <TableCell component="th" id={labelId} scope="row">
                                                {row.code}
                                            </TableCell>
                                            <TableCell component="th" id={labelId} scope="row">
                                                {row.betStartDate ? format(new Date(row.betStartDate), 'dd MM yyyy HH:mm') : "-"}
                                            </TableCell>
                                            <TableCell component="th" id={labelId} scope="row">
                                                {row.expiredDate && format(new Date(row.expiredDate), 'dd MM yyyy HH:mm')}
                                            </TableCell>
                                            <TableCell component="th" id={labelId} scope="row">
                                                {row.productName}
                                            </TableCell>
                                            <TableCell component="th" id={labelId} scope="row">
                                                {row.totalAmount}
                                            </TableCell>
                                            <TableCell component="th" id={labelId} scope="row">
                                                {row.circulationJackpot?.amount}
                                            </TableCell>
                                            <TableCell component="th" id={labelId} scope="row">
                                                {!row.isResulted && Circulation_SaveResult ? (
                                                    <div className="d-flex justify-content-center">
                                                        <Tooltip title="Nəticələri qeyd et" placement="top">
                                                            <button
                                                                aria-label="edit"
                                                                className="btn btn-sm btn-icon btn-bg-light btn-text-warning btn-hover-warning mr-2"
                                                                onClick={() => {
                                                                    setChooseGroupId(row.id);
                                                                    setShowCheckGames(true);
                                                                    setCirculationNumber(row.code)
                                                                }}
                                                            >
                                                                <CheckIcon/>
                                                            </button>
                                                        </Tooltip>
                                                    </div>
                                                ) : <div className="d-flex justify-content-center">Tur
                                                    dəyərləndirilmişdir</div>}
                                            </TableCell>
                                            <TableCell component="th" id={labelId} scope="row">
                                                {row.resultedDate ? format(new Date(row.resultedDate), 'dd MM yyyy HH:mm') : ""}
                                            </TableCell>
                                            <TableCell
                                                component="th"
                                                id={labelId}
                                                scope="row"
                                                padding="none"
                                            >
                                                <Tooltip title={row.isActive ? "Tur aktivdir" : "Aktiv et"}
                                                         placement="top">
                                                    <span>
                                                        <button
                                                            aria-label="status"
                                                            className={`btn btn-sm btn-icon btn-bg-light btn-hover-bg-secondary mr-2 ${row.isActive ? "btn-text-success" : "btn-text-dark"}`}
                                                            onClick={() => {
                                                                setShowCirculationActivation(true);
                                                                setChooseGroupId(row.id);
                                                                setIsActivate(!row.isActive)
                                                            }}
                                                        >
                                                        <PowerSettingsNewIcon/>
                                                    </button>
                                                    </span>
                                                </Tooltip>
                                                {Circulation_Update && (
                                                    <Tooltip
                                                        title="Səbəbləri göstər"
                                                        placement="top">
                                                        <button
                                                            aria-label="view"
                                                            className="btn btn-sm btn-icon btn-bg-light btn-text-info btn-hover-info mr-2"
                                                            onClick={() => {
                                                                setReasons(row.activationHistory);
                                                                setShowReasons(true)
                                                            }}
                                                        >
                                                            <InfoIcon/>
                                                        </button>
                                                    </Tooltip>
                                                )}
                                                <Tooltip title="Göstər" placement="top">
                                                    <button
                                                        aria-label="view"
                                                        className="btn btn-sm btn-icon btn-bg-light btn-text-info btn-hover-info mr-2"
                                                        onClick={() => {
                                                            setChooseGroupId(row.id);
                                                            setOpenView();
                                                        }}
                                                    >
                                                        <EyeIcon/>
                                                    </button>
                                                </Tooltip>
                                                {Circulation_Update && (
                                                    <Tooltip
                                                        title={row.possibleSeeTotalAmount ? "Məbləği gizlə" : "Məbləği göstər"}
                                                        placement="top">
                                                        <button
                                                            aria-label="view"
                                                            className="btn btn-sm btn-icon btn-bg-light btn-text-info btn-hover-info mr-2"
                                                            onClick={() => {
                                                                putSeeTotalAmount(row.id, !row.possibleSeeTotalAmount)
                                                            }}
                                                        >
                                                            {row.possibleSeeTotalAmount ? <AttachMoneyIcon/> :
                                                                <MoneyOffIcon/>}
                                                        </button>
                                                    </Tooltip>
                                                )}
                                                {row.canBeModified && !row.isResulted && Circulation_Update ?
                                                    <Tooltip title="Düzəliş et" placement="top">
                                                        <button
                                                            aria-label="edit"
                                                            className="btn btn-sm btn-icon btn-bg-light btn-text-dark btn-hover-dark mr-2"
                                                            onClick={() => {
                                                                setChooseGroupId(row.id);
                                                                setShowEdit(true);
                                                            }}
                                                        >
                                                            <EditIcon/>
                                                        </button>
                                                    </Tooltip>
                                                    : ""}

                                                {row.canBeModified && !row.isResulted && Circulation_Delete ?
                                                    <Tooltip title="Sil" placement="top">
                                                        <button
                                                            aria-label="Delete"
                                                            className="btn btn-sm btn-icon btn-bg-light btn-text-danger btn-hover-danger"
                                                            onClick={() => {
                                                                setChooseGroupId(row.id);
                                                                setShowRemove(true);
                                                            }}
                                                        >
                                                            <DeleteIcon/>
                                                        </button>
                                                    </Tooltip>
                                                    : ""}
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    ) : !groups.length && !isLoading && !isError ? (
                        <AlertComponent variant="info" message="Məlumat tapılmadı."/>
                    ) : (!isLoading && isError && (!isLoading && isError && (<AlertComponent
                        variant="danger"
                        message="Şəbəkəylə bağlantı kəsildi."
                    />)))}
                </div>
                {totalCount > 10 && (
                    <ThemeProvider theme={theme}>
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25]}
                            component="div"
                            count={totalCount}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            backIconButtonProps={{
                                "aria-label": "Previous Page",
                            }}
                            nextIconButtonProps={{
                                "aria-label": "Next Page",
                            }}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handleChangeRowsPerPage}
                        />
                    </ThemeProvider>
                )}
            </Paper>
        </div>
    );
}
